import { Injectable } from '@angular/core';
import { HttpClient, HttpHandler, HttpParams, HttpHeaders, HttpErrorResponse } from '@angular/common/http';
import { Observable, throwError } from 'rxjs';
import { map, catchError } from 'rxjs/operators';
import { AuthenticationService } from '../../../authentication/authentication.service';
import { AuthDispatcher } from '../../../store/auth/auth-dispatcher';
import { environment } from '../../../../environments/environment';
import { Router } from '@angular/router';
import { TranslationService } from '../../../common/services/languages/translation.service';
import { NgRedux } from '@angular-redux/store';
import { AppState } from '../../../store/state.model';
import { ApiRequestParams } from '../../report-form/report.interface';

/** Creates custom http calls get or post */
export class ReportHttpParams extends HttpParams {
  constructor(public spec: string) {
    super();
  }
}
/** Handles the Api calls with the body or header deired
 * allow the client perform custom logic on the error/succes payloads
 */
@Injectable()
export class ReportApiHandlerService extends HttpClient {
  /**
   * @var This property will host the value of the enviroment where needs to be done the API/Endpoint call
   **/
  private environment: string;

  /**
   * @var This property will determine the type of the api call
   **/
  private requestType: string;
  constructor(
    private httpHandler: HttpHandler,
    private authService: AuthenticationService,
    private authDispatcher: AuthDispatcher,
    public reduxState: NgRedux<AppState>,
    public router: Router,
    public translate: TranslationService,
    public ngRedux: NgRedux<AppState>
  ) {
    super(httpHandler);
  }

  /**
   * @event intercept Intercept any request that is triggered by APIHandler and sets the common header of the ORCH layer
   * @returns The response that is being intercepted so it can continue to the Network call
   **/
  getTypeParams() {
    return !!this.requestType
      ? new ReportHttpParams(this.requestType)
      : new ReportHttpParams('default');
  }
  /** This method gets a request to the passed url and options */
  getRequest(url: string, options: ApiRequestParams): Observable<any> {
    const headers: HttpHeaders = this.getHeaders(options);
    return super
      .get(`${this.environment}${url}`, {
        headers: headers,
        params: this.getTypeParams(),
      })
      .pipe(
        map((res: any) => {
          return res;
        }),
        catchError(this.handleError.bind(this))
      );
  }

  /** This method adds the custom headers taken from the user input to the http request */
  getHeaders(data: ApiRequestParams): HttpHeaders {
    this.environment = environment.svpp_gateway;
    this.requestType = !!data && !!data.type ? data.type : 'default';
    let headers = new HttpHeaders();
    headers = headers.set('Content-Type', 'application/json');
    if (!!data && !!data.params) {
      const params = data.params;
      for (const report of params.reports) {
        headers = headers.set(report.name, report.value);
      }
      headers = headers.set(params.start_date.name, params.start_date.value);
      headers = headers.set(params.end_date.name, params.end_date.value);
    }
    return headers;
  }
  /** This method handles the errors of a http request*/
  handleError(err: HttpErrorResponse): Observable<ArrayBuffer> {
    if (this.isAuthenticationError(err)) {
      return throwError(() => ({ errorCode: 'UNAUTHORIZED' }));
    }
    const errorCode =
      this.checkErrorContent(err) &&
      err.error.status.messages.map((error) => error.responseCode);
    const throwObj = !!errorCode && errorCode.length ? errorCode : [err.status];
    const errorResponse = { success: false, errorCode: throwObj[0] };
    return throwError(() => errorResponse);
  }
  /** This method determines if it is an authentication error from the api gateway*/
  isAuthenticationError(err: HttpErrorResponse): boolean {
    if (
      (this.checkErrorContent(err) &&
        err.error.status.messages[0].detailedDescription.indexOf('expired') >
        0) ||
      (err.status === 0 && err.ok === false &&
        err.statusText === 'Unknown Error') ||
      (err.status === 403 && this.checkErrorContent(err) &&
        err.error.status.messages[0].responseCode === 'APIGW-403')
    ) {
      this.routeError();
      this.authDispatcher.logout();
    }
    return (
      (err.status === 0 && err.ok === false &&
        err.statusText === 'Unknown Error') ||
      (err.status === 403 && this.checkErrorContent(err) &&
        err.error.status.messages[0].responseCode === 'APIGW-403')
    );
  }
  /** This checks the structure of the error if there is a status object*/
  checkErrorContent(err: HttpErrorResponse): boolean {
    return (
      err.error &&
      err.error.status &&
      err.error.status.messages &&
      err.error.status.messages.length
    );
  }
  /*
   * @function routeError routes to error page
   * @returns void
   **/
  private routeError(): void {
    this.router.navigate(['dashboard/error'], {
      queryParams: {},
      skipLocationChange: true,
    });
  }
}
